<template>
  <div v-loading="loading" class="evaluations">
    <div class="filters-before-table">
      <search-input
        placeholder="Поиск по названию"
        style="width: 300px"
        v-model="filters.search"
        @change="filtersChanged"
      >
      </search-input>
      <eval-evaluation-status-select
        v-model="filters.statuses"
        @change="filtersChanged"
      ></eval-evaluation-status-select>
      <el-switch
        style="margin-left: 20px"
        v-model="filters.only_active"
        :active-value="1"
        :inactive-value="0"
        active-text="Только активные"
        @change="filtersChanged"
      >
      </el-switch>
    </div>
    <div class="evaluation-block">
      <el-table
        :data="evaluations"
        :show-header="!!evaluations.length"
        empty-text="Нет созданных оценок"
      >
        <el-table-column prop="name" label="Название">
          <template v-slot="scope">
            <router-link
              class="table-router-link"
              :to="{ name: 'EvalEvaluation', params: { id: scope.row.id } }"
              target="_blank"
            >
              {{ scope.row.name }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column width="300" prop="status" label="Статус">
          <template v-slot="scope">
            {{ scope.row.status_label }}
          </template>
        </el-table-column>
        <el-table-column width="90" prop="disabled" label="Активна">
          <template v-slot="scope">
            <span v-if="scope.row.disabled">Нет</span>
            <span v-else>Да</span>
          </template>
        </el-table-column>
        <el-table-column width="80" align="right" label="">
          <template v-slot="scope">
            <el-button
              class="table-action-button"
              style="margin-right: 10px"
              size="mini"
              round
              icon="fas fa-pen"
              @click="onEditEvaluation(scope.row)"
            >
            </el-button>
            <el-popconfirm
              confirm-button-text='Да'
              cancel-button-text='Нет'
              icon="el-icon-question"
              title="Вы уверены, что хотите удалить оценку 360?"
              @confirm="deleteEvaluation(scope.row)"
            >
              <el-button
                slot="reference"
                class="table-action-button"
                size="mini"
                round
                icon="far fa-trash-alt"
              >
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <paginator
      :paginator.sync="paginator"
      use-router-query-param
      @page-changed="loadEvaluations"
    ></paginator>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import EvalEvaluationStatusSelect from "@/modules/evaluation/components/EvalEvaluationStatusSelect.vue";
import {paginator} from "@/mixins/paginator";

export default {
  name: "evaluations-component",
  components: {EvalEvaluationStatusSelect, Paginator, SearchInput},
  mixins: [paginator],
  props: {
    onEditEvaluation: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      evaluations: [],
      filters: {},
    }
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  mounted() {
    this.loadEvaluations();
  },
  methods: {
    loadEvaluations() {
      this.loading = true;
      this.$api.evaluation.evaluationSearch({
        ...this.filters,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.evaluations = data.evaluations;
          this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteEvaluation(evaluation) {
      this.loading = true;
      this.$api.evaluation.evaluationDelete({
        ids: [evaluation.id]
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Оценка 360 успешно удалена'
          });
        })
        .finally(() => {
          this.loadEvaluations();
        })
    },
    filtersChanged() {
      this.loadEvaluations();
    }
  }
}
</script>

<style scoped lang="scss">
  .evaluations {

    .table-router-link {
      text-decoration: none;
    }
  }
</style>